<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black bg-opacity-50" @click="close"></div>
    
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
      <!-- Close button -->
      <button @click="close" class="absolute top-3 right-3 text-gray-400 hover:text-gray-500">
        <i class="fas fa-times h-5 w-5"></i>
      </button>
      
      <!-- Title and message -->
      <h3 class="text-lg font-light text-gray-900 mb-4 text-center">Welcome to Nevua Markets</h3>
      <p v-if="message.length > 0" class="text-gray-600 mb-6 text-light">{{ message }}</p>
      
      <!-- LoginMenu component - forced to be visible by passing true to v-show -->
      <div class="flex justify-center">
        <LoginMenu 
          buttonClass="hidden" 
          menuClass="static w-full shadow-none ring-0 p-0"
          :showText="false"
          :showAuthModal="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LoginMenu from '../components/menus/LoginMenu.vue'

export default {
  name: 'AuthModal',
  components: {
    LoginMenu
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script> 